import { AxiosResponse } from 'axios';
import { FnbItemGetDto, FnbOrderGetDto, FnbOrderGetWithItemsDto, ResultDto, QuantityGetDto, FnbInvoiceGetDto } from 'svila-common';

import { API_URL } from '../../utils/constants';
import request from '../request';

export default {

  get: async (id: string): Promise<AxiosResponse<FnbInvoiceGetDto>> => {
    return request(`${API_URL}/fnb-invoices/get/${id}`, 'get');
  },
};
